import createApp from 'wap/plugins/create-app.js'
import router from 'wap/router/index.js'
import DefaultLayout from 'wap/layout/default.vue'

createApp(DefaultLayout, { router })
